<template>
  <div class="crud-edit-for-side-modal">
    <pangu-side-modal
      :transfer="transfer"
      :modify="modify"
      class="crud-edit-for-side-modal-class"
      v-model="showModal"
      :zIndex="zIndex"
      :title="title"
      :needConfirm="needConfirm"
      :sideModalWidth="sideModalWidth"
      :sideModalBodyOverflowY="sideModalBodyOverflowY"
      sideModalBodyPadding="20"
      :footerHide="footerHide"
      @on-ok="onOk"
      @on-cancel="onCancel"
    >
      <div
        class="crud-edit-for-side-modal-formRef"
        :style="{ paddingLeft: paddingLeft + 'px', paddingRight: paddingRight + 'px' }"
      >
        <div v-if="responseData && responseData.errors && responseData.errors.length > 0">
          <topRemind :autoHeight="true" :value="responseData.errors"></topRemind>
        </div>
        <Button
          v-if="menuAddChooseShow"
          class="pg_tableButtonCustomCss"
          shape="circle"
          :type="'primary'"
          custom-icon="ivu-icon-icon-pg-add"
          @click="handleToolbarMenuChoose()"
          >{{ menuAddChooseName }}</Button
        >
        <dynamicFrom
          v-if="refreshDynamicFrom && definitionList"
          :options="fromOptions"
          :store="store"
          :useBackCount="useBackCount"
          :formProps="formProps"
          :definitionList="definitionList"
          v-model="formData"
          :executeFormControl="true"
          ref="crudEditForSideModalFormRef"
        ></dynamicFrom>
      </div>
      <div slot="footer">
        <Button
          v-if="isShowDraft"
          shape="circle"
          type="primary"
          :loading="handleSubmitLoadingDraft"
          @click="changeIsDraft()"
          >{{ sideModalBtnDraft }}</Button
        >
        <Button shape="circle" type="primary" :loading="handleSubmitLoading" @click="handleSave()">
          {{ sideModalBtn }}
          <Poptip v-if="labelTip" trigger="hover" transfer>
            <template slot="content">
              <div style="width: 200px; white-space: normal" v-html="labelTip"></div>
            </template>
            <span style="padding-top: 2px; display: inline-block; margin-left: 6px">?</span>
          </Poptip>
        </Button>
        <Button
          v-if="anewAndSure || secondSave"
          style="margin-left: 20px"
          shape="circle"
          type="primary"
          :disabled="disabledAnewAndSure"
          :loading="handleSubmitLoadingAnew"
          @click="handleSave(anewAndSure, secondSave)"
          >{{ anewSideModalBtn }}</Button
        >
      </div>
    </pangu-side-modal>
    <pangu-side-modal
      class="selectSideModal"
      v-model="showChooseModal"
      :zIndex="zIndex"
      :title="menuAddChooseModalTitle"
      :sideModalWidth="sideModalSecondWidth"
      :footerHide="true"
      :onSide="true"
    >
      <keywordSearchTable
        :height="tableHeight"
        :url="menuAddChooseUrl"
        :index="menuAddChooseIndex"
        :requestMethod="menuAddChooseRequestMethod"
        :requestParam="menuAddChooseRequestParam"
        :searchKey="menuAddChooseSearchKey"
        :placeholder="menuAddChooseplaceholder"
        :tableColumnDef="menuAddChooseTableColumnDef"
        @row-click="rowClickChoose"
        v-model="selectData"
      >
      </keywordSearchTable>
    </pangu-side-modal>
  </div>
</template>
<script>
import compileVariableUtil from '../../static/js/compileVariableUtil'
import createFormConverterUtil from '../../static/js/createFormConverterUtil'
import menuUtils from '../../static/js/menuUtil.js'
import objectUtil from '../../static/js/objectUtil'
import { formatDate } from '../../static/js/dateUtils'
import Emitter from '../mixins/emitter'
import props from './props'
import templateUtil from '../../static/js/templateUtil'
export default {
  name: 'crudEditForSideModal',
  provide() {
    return {
      parentVue: this,
    }
  },
  props,
  mixins: [Emitter],
  data() {
    return {
      onSide: true, //用来标识在侧滑，接受抛出事件
      refreshDynamicFrom: false,
      selectData: null,
      showChooseModal: false,
      tableHeight: null,
      modify: false, //标识是否进行保存提示

      fromOptions: {
        // 是否启用 未保存提示。
        saveTipFlag: true,
        // 将当前表单对象放到全局对象（globalDataKey)中。便于子类动态(parentGlobalDataKey)表单中获取。
        globalDataKey: null,
        parentGlobalDataKey: 'parentFormData',
      },
      formProps: null,
      definitionList: null,

      // #6354，提交是否报错
      submitIsError: false,

      // 表单定义配置
      //在vue将以_和$开头的属性或者data中的变量认为是vue的保留成员,禁⽌这样使⽤,
      //eslint-disable-next-line
      _formItemsDef: this.formItemsDef,
      showModal: this.show,
      formData: this.getDefaultFormData(),
      handleSubmitLoading: false, // 是否请求中
      handleSubmitLoadingAnew: false,
      handleSubmitLoadingDraft: false,
      data: [{ extend: { insert_: 1123 } }],
      responseData: null,
      isDraft: false,
    }
  },
  computed: {
    // #6354，报错前禁止 anewAndSure 提交按钮
    // 需求 6807 增加 !this.anewAndSureReqObj
    disabledAnewAndSure() {
      return this.anewAndSureUrlSave && !this.submitIsError && !this.anewAndSureReqObj
    },
  },
  watch: {
    show(val) {
      this.showModal = val
    },
    value(val) {
      this.formData = val
    },
    showModal(val) {
      if (val && this.urlGetOfEdit) {
        this.getOfEdit()
      }
    },
    // 确认选择数据
    formData(val) {
      if (!this.urlGetOfEdit) {
        this.$emit('input', val)
      }
      // if(this.GLOBAL.isDebug)console.log(val);
    },
  },

  mounted: function () {
    if (this.urlItemsDef) {
      this.formItemsDefData = null
      this.loadItemsDef()
    } else {
      this.createFormCreate(this.formItemsDef)
    }
    if (!this.tableHeight) {
      this.tableHeight = window.innerHeight - 157
    }
    // 需求6128 侧滑的表单，支持配置一些初始值 这些值我们不让他和外界关联，因此用clone(),
    // 使用点：IECM-客户商品映射管理-(ROWTABLE_MODIFY_HANDLE)手动录入映射商品信息-按钮相关配置，侧滑(IECM_GOODS_MAPING_TABLE_HANDLE_FROM)
    if (this.begFormData) {
      //需求7478 需要缓存 表单的字段到本地
      if (this.cacheKey) {
        let cacheData = JSON.parse(localStorage.getItem(this.cacheKey))
        const oldData = objectUtil.clone(Object.assign(this.formData || {}, this.begFormData))
        this.formData = objectUtil.clone(
          Object.assign(this.formData || {}, this.begFormData, cacheData)
        )

        // 处理不取缓存的字段
        if (this.noCaches?.length) {
          this.noCaches.forEach((fieldProp) => {
            if (['order.date'].includes(fieldProp)) {
              const today = formatDate(new Date(), 'YYYY-MM-DD')
              objectUtil.setValueByPath(this.formData, fieldProp, today)
            } else {
              objectUtil.setValueByPath(
                this.formData,
                fieldProp,
                objectUtil.getValueByPath(oldData, fieldProp)
              )
            }
          })
        }

        if (this.changePath) {
          //这里为了解决缓存中的字段覆盖表单的字段 特殊处理  formData.order 被覆盖
          objectUtil.setValueByPath(
            this.formData,
            this.changePath,
            objectUtil.getValueByPath(this.begFormData, this.changePath)
          )
        }
      } else {
        this.formData = objectUtil.clone(Object.assign(this.formData || {}, this.begFormData))
      }

      // 需求 #7758
      if (this.changeFields) {
        const compileData = compileVariableUtil.getCompileVariable(this.begFormData, this)
        const compileFields = templateUtil.compileData(this.changeFields, compileData)

        if (compileFields?.length) {
          compileFields.forEach((field) => {
            objectUtil.setValueByPath(this.formData, field.path, field.value)
          })
        }
      }
    }
  },
  created() {
    if (!this.urlGetOfEdit) {
      this.refreshDynamicFrom = true
    }
  },

  beforeDestroy: function () {},
  methods: {
    getDefaultFormData() {
      if (this.setPathNull) {
        let temp = objectUtil.clone(this.value)
        objectUtil.setValueByPath(temp, this.setPathNull, null)
        return temp
      } else {
        return this.value
      }
    },
    changeIsDraft() {
      this.isDraft = true
      this.handleSave()
    },
    sideItemDynamicOnModify() {
      this.modify = true
    },
    handleToolbarMenuChoose() {
      this.selectData = null
      this.showChooseModal = !this.showChooseModal
    },
    rowClickChoose(row) {
      this.formData = row
      this.showChooseModal = false
    },
    handleSave(anewAndSure, secondSave) {
      var that = this
      // 需求 6807  增加anewAndSureReqObj?.needFormValidate 支持 点击anewAndSure按钮 不对表单校验
      if (!this.anewAndSureReqObj || this.anewAndSureReqObj?.needFormValidate == true) {
        this.$refs['crudEditForSideModalFormRef'].validate((valid) => {
          if (valid) {
            this.$Loading.start()
            this.HandlePostFunc(anewAndSure, secondSave)
            this.$Loading.finish()
          } else {
            that.$Message.error('请完善必填信息!')
          }
        })
      } else {
        this.$Loading.start()
        this.HandlePostFunc(anewAndSure, secondSave)
        this.$Loading.finish()
      }
    },
    saveDate(anewAndSure, formData, secondSave) {
      var that = this
      that.save(
        formData,
        (res) => {
          if (!that.needConfirm && !anewAndSure) {
            that.showModal = false
          }
          // 需求：6807  如果当前动作执行完成后，还有后续动作要执行,就配置hasAfterAction属性
          if (this.anewAndSureReqObj?.hasAfterAction) {
            that.onOk(res)
          } else if (anewAndSure && that.urlGetOfEdit) {
            that.getOfEdit()
            that.modify = false
          } else {
            that.onOk(res)
          }
        },
        anewAndSure,
        secondSave
      )
    },
    loadItemsDef() {
      if (!this.urlItemsDef) {
        return
      }
      this.$Loading.start()
      this.$axios
        .get(this.urlItemsDef)
        .then((res) => {
          this.$Loading.finish()

          if (!this.$cfn.ajax1.isOK(res, this)) return
          //eslint-disable-next-line
          this._formItemsDef = res.data.data
          this.createFormCreate(this._formItemsDef)

          this.initFlag = true
        })
        .catch((res) => {
          this.$Loading.error()
          this.$cfn.ajax1.catch1(res, this)
        })
    },

    createFormCreate: async function (data) {
      // 兼任form-create本身结构体，和盘谷定义结构体。
      data = createFormConverterUtil.converterByDictFormData(data)

      // 兼容老模式直接返回列表
      var formItems = data.items || data

      // 只显示可见表单元素
      formItems = createFormConverterUtil.getItemsForFilterVisible(formItems, data, this)
      if (this.GLOBAL.isDebug) console.log('formItems', formItems)

      this.definitionList = formItems
      this.formProps = createFormConverterUtil.getCreateFormProps(data.form, this.propsForm)
      if (this.urlGetOfEdit) {
        let result = await this.getOfEdit()
        if (!result) {
          return false
        }
      }
      this.definitionList.map((im) => {
        if (im.defaultValue) {
          // 首先判断，data中是否有值
          let value = templateUtil.compileData(im.defaultValue, this.formData)
          let curValue = objectUtil.getValueByPath(this.formData, im.field)
          if (curValue) {
            objectUtil.setValueByPath(this.formData, im.field, curValue)
          } else if (value) {
            objectUtil.setValueByPath(this.formData, im.field, value)
          }
        }
      })
    },
    getOfEdit() {
      return new Promise((resolve, reject) => {
        const method = this.methodsGet.toLowerCase()
        let params = Object.assign({}, this.parameterGet, this.otherParameter)
        if (method == 'get') {
          params = {
            params,
          }
        }
        this.$Loading.start()
        this.$axios[method](this.urlGetOfEdit, params)
          .then((res) => {
            this.$Loading.finish()
            if (`${res.data.code}` == '400') {
              if (res.data.errors && res.data.errors.length > 0) {
                this.responseData = res.data
                this.$Message.success('失败')
              }
              return false
            }
            if (!this.$cfn.ajax1.isOK(res, this)) {
              this.showModal = false
              return false
            }
            //将某些字段根据配置进行转换
            if (this.transformField && res.data.data) {
              const temTransformField = {}
              Object.keys(this.transformField).forEach((field) => {
                temTransformField[field] = `{{${this.transformField[field]}}}`
              })
              const transformData = templateUtil.compileData(temTransformField, res.data)
              Object.keys(transformData).forEach((key) => {
                if (transformData[key] !== undefined)
                  objectUtil.setValueByPath(res.data.data, key, transformData[key])
              })
            }
            if (this.needMergFormData) {
              this.formData = Object.assign(res.data.data, this.formData)
            } else {
              this.formData = res.data.data
            }

            const filters = this.definitionList.filter((im) => im.type === 'crudArrayOrder')

            //  this.updateFormCreateData(this.formData);
            this.initFlag = true
            // this.$nextTick(() => {
            //     const formRef = this.$refs.crudEditForSideModalFormRef;
            //     formRef && formRef.formControl();
            // })
            //  获取到表单配置数据之后，强制刷新动态表单，再执行模板表达式
            this.refreshDynamicFrom = false
            this.$nextTick(() => {
              filters.map((item) => {
                this.formData[item.property] = (res.data.data[item.property] || []).map((item) => {
                  item._ID = item._ID || objectUtil.createID()
                  return item
                })
              })

              const formRef = this.$refs.crudEditForSideModalFormRef
              formRef && formRef.formControl()
              this.refreshDynamicFrom = true
              resolve(true)
            })
          })
          .catch((res) => {
            this.$Loading.error()
            this.$cfn.ajax1.catch1(res, this)
            reject(false)
          })
      })
    },

    onOk(res) {
      this.getCompleteRes ? this.$emit('on-ok', res || {}) : this.$emit('on-ok', this.formData)
    },

    onOkAndContinue(res) {
      this.getCompleteRes
        ? this.$emit('on-ok-and-continue', res || {})
        : this.$emit('on-ok-and-continue', this.formData)
    },
    onCancel() {
      this.initAndClearItems()
      this.$emit('on-cancel')
    },
    initAndClearItems() {
      console.log('initClearItems: ', this.initClearItems)
      if (this.initClearItems) {
        this.formData.items = []
        this.store.states.shoppingData.formData.items = []
        this.$emit('input', this.formData)
      }
    },
    save(formData, callback, anewAndSure, secondSave) {
      if (this.GLOBAL.isDebug) console.log('save', formData)
      if (!this.urlSave) {
        this.formData = formData
        if (callback) callback()
        return
      }
      if (anewAndSure && this.handleSubmitLoadingAnew) {
        return
      }
      if (!anewAndSure && this.handleSubmitLoading) {
        return
      }
      if (anewAndSure) {
        this.handleSubmitLoadingAnew = true
      } else if (this.isDraft) {
        this.handleSubmitLoadingDraft = true
      } else {
        this.handleSubmitLoading = true
      }

      let params = formData

      // 需求 6128 需要将formData包装成数组 因此增加了参数formDataIsArray,为了不改变之前的逻辑，避免出错，我们新增一个参数convertFormData
      let convertFormData = null
      if (this.formDataIsArray) {
        convertFormData = [formData]
      }
      if (this.urlSaveKey) {
        params = Object.assign({}, this.saveParam)
        // 需求 6128 在这里增加一下convertFormData判断
        params[this.urlSaveKey] = convertFormData ? convertFormData : formData
      }
      //需求 8335 增加一个保存按钮
      else if (this.isDraft) {
        params = Object.assign({}, formData, this.draftParam)
        if (this.draftParam?.order) params.order = { ...formData.order, ...this.draftParam?.order }
      }
      // 将formData和传入的参数合并到一起
      else if (!this.isDraft && this.sureParam) {
        params = Object.assign({}, formData, this.sureParam)
        // #36583
        // 如果仅仅只是执行上面的 Object.assign 则只会讲 sureParam 中定义了的字段替换 formData 上的字段而非追加
        // 如下改动实现将 sureParam 上定义的字段追加进 params 中，并保留其他的在 formData 上的字段
        // formData.order: { a: {...}, b: {...}: c: {...} }
        // sureParam.order: { b: { new: {...}} }
        // 执行后得到 formData.order: { a: {...}, b: {..., new: {...}}: c: {...} }
        // 原字段 b 上的其他得以保留
        if (this.sureParam?.order) params.order = { ...formData.order, ...this.sureParam?.order }
      }
      // 提交参数格式化处理
      else if (
        this.dataKeyOfUrlSave &&
        this.paramKeyOfUrlSave &&
        formData.hasOwnProperty(this.dataKeyOfUrlSave) &&
        Array.isArray(formData[this.dataKeyOfUrlSave]) &&
        Array.isArray(this.formatOfUrlSave) &&
        this.formatOfUrlSave.length > 0
      ) {
        // 需求 #5491 需要额外传递参数 enable
        params = Object.assign({}, this.saveParam)
        params[this.paramKeyOfUrlSave] = formData[this.dataKeyOfUrlSave].map((item) => {
          let temp = this.formatOfUrlSave.length > 1 ? {} : []
          this.formatOfUrlSave.forEach((key) => {
            if (item.hasOwnProperty(key)) {
              this.formatOfUrlSave.length > 1 ? (temp[key] = item[key]) : (temp = item[key])
            }
          })
          return temp
        })
      } else if (
        this.isAssignParamKeyOfUrlSave &&
        this.dataKeyOfUrlSave &&
        formData.hasOwnProperty(this.dataKeyOfUrlSave)
      ) {
        // 需求#5684，只需要传递 formData 上指定的属性
        params = Object.assign({}, this.saveParam)
        if (this.paramKeyOfUrlSave) {
          params[this.paramKeyOfUrlSave] = formData[this.dataKeyOfUrlSave]
        } else {
          params = Object.assign({}, formData[this.dataKeyOfUrlSave])
        }
      }
      /**
       *  需求 6128 由于上面一段判断都是if else 判断，所以，如果修改可能会改变原有逻辑，因此为了兼容，再最后再补充一些逻辑
       *  根据上面代码，由于，this.sureParam 作用是与formData合并的，但是this.urlSaveKey存在的话，就不会走下一步了
       * 因此增加参数 paramConnectWithFormData 参数，如果存在，就跟params 平级，把这些参数加进去
       *  */
      if (this.paramConnectWithFormData) {
        params = Object.assign({}, params, this.paramConnectWithFormData)
      }
      // #8346 自定义参数处理
      if (this.customParamFunc) {
        console.log('customParamFunc formData: ', formData)
        params = this.customParamFunc(formData)
      }

      //解决需要显示保存和提交两个按钮时，提交按钮需要将参数设置为true
      if (secondSave) {
        params = objectUtil.clone(params)
        objectUtil.setValueByPath(params, secondSave, true)
      }
      //7137 【按采购入库单添加】
      if (this.sureOtherParameter) {
        params = objectUtil.clone(params)
        objectUtil.setValueByPath(
          params,
          this.sureOtherParameter?.path,
          this.sureOtherParameter?.val
        )
      }

      this.$Loading.start()
      /**
       * #6354 【灵科-web】启用了“补货申请时间设置”功能时，如果未在补货申请时间范围内，允许生成草稿状态的单据
       * ! else 分支是原来的逻辑
       */
      if (anewAndSure && this.anewAndSureUrlSave) {
        this.$axios
          .post(this.anewAndSureUrlSave, params)
          .then((res) => {
            this.$Loading.finish()
            if (res.data.code == '400') {
              if (res.data.errors && res.data.errors.length > 0) {
                this.responseData = res.data
                this.$Message.success('失败')
                // this.forceSubmit(formData, res, anewAndSure)
                return false
              }
            }
            this.responseData = null
            if (!this.isOKForAjax(res, this)) return

            this.submitIsError = false
            this.$Message.success('成功')
            if (callback) callback(res)
          })
          .catch((res) => {
            this.$Loading.error()

            this.$cfn.ajax1.catch1(res, this)
          })
          .finally(() => {
            if (anewAndSure) {
              this.handleSubmitLoadingAnew = false
            } else {
              this.handleSubmitLoading = false
            }
          })
      } else {
        this.$axios
          .post(this.urlSave, params)
          .then((res) => {
            if (anewAndSure) {
              this.handleSubmitLoadingAnew = false
            } else if (this.isDraft) {
              this.isDraft = false
              this.handleSubmitLoadingDraft = false
            } else {
              this.handleSubmitLoading = false
            }
            this.$Loading.finish()
            if (res.data.code == '400') {
              if (res.data.errors && res.data.errors.length > 0) {
                this.responseData = res.data
                this.submitIsError = true // #6354 新增的
                this.forceSubmit(formData, res, anewAndSure, secondSave)
                return false
              }
              // 需求：4021 添加人：lqn 用例：配送单：打印/批量打印 侧滑展开点击底部打印时就走这里的逻辑
              if (this.identifyAndContinue) {
                this.$pgMessage.confirm({
                  title: '提示',
                  content: res.data.msg,
                  onOk: () => {
                    this.onOk(res)
                    return false
                  },
                  cancel: () => {
                    this.onCancel()
                    return false
                  },
                })
                return false
              }
            }
            this.responseData = null
            if (!this.isOKForAjax(res, this)) return
            if (this.needPGMessageConfirm) {
              this.$pgMessage.confirm({
                title: '结果',
                content: res.data.msg,
              })
            }
            if (this.urlSaveKey && res.data && res.data.data && res.data.data[this.urlSaveKey]) {
              this.formData = res.data.data[this.urlSaveKey]
            } else {
              this.formData = res.data.data
            }
            if (res.data.progressTask) {
              //异步任务
              menuUtils.special
                .progressTask(this, res.data.progressTask, this.progressParam)
                .then(() => {
                  if (callback) callback(res)
                })
            } else {
              if (!this.needPGMessageConfirm && this.needMessage) this.$Message.success('成功')
              if (callback) callback(res)
            }
          })
          .catch((res) => {
            if (anewAndSure) {
              this.handleSubmitLoadingAnew = false
            } else {
              this.handleSubmitLoading = false
            }
            this.$Loading.error()

            this.$cfn.ajax1.catch1(res, this)
          })
      }
    },
    isOKForAjax(res, vue) {
      if (!res.data) {
        if (vue.GLOBAL.isDebug) console.log('isOK:res.data is null', res)
        return false
      }
      if (res.data.code == 200) return true
      else {
        var errorMsg = res.data.msg
        if (errorMsg === undefined) {
          if (vue.GLOBAL.isDebug) console.error('ajax1.isOK(res)', res)
          errorMsg = '请求接口协议不正确，地址：' + res.config.url
        }
        if (vue && vue.$pgMessage) {
          // if (errorMsg === '数据违反唯一约束') errorMsg = '已存在证照类型、关联性质相同、经营属性相同的证照类型。';
          vue.$pgMessage.confirm({
            title: '提示',
            content: errorMsg,
          })
          return false
        } else console.log(errorMsg)
        if (vue && vue.$Message) {
          vue.$Message.error(errorMsg)
          return false
        } else console.log(errorMsg)
      }
      return false
    },
    //强制提交逻辑
    forceSubmit(formData, res, anewAndSure, secondSave) {
      let errorArr = res.data.errors || []
      const msg = res.data.msg

      for (let i = 0; i < errorArr.length; i++) {
        if (errorArr[i].level == 1) {
          if (!this.closeForceSubmitConfirmMsg) {
            this.$pgMessage.confirm({
              title: '提示',
              content: msg,
            })
          }
          return
        }
      }

      this.$pgMessage.confirm({
        title: '确认提示',
        content: msg || '确认提交',
        sureBtnText: '继续提交',
        showCancelBtn: true,
        cancelBtnText: '查看问题',
        onOk: () => {
          let tempFormData = objectUtil.clone(formData)
          tempFormData.forceSubmit = true
          this.saveDate(anewAndSure, tempFormData, secondSave)
        },
      })
    },
    // 需求：6807 抽出了提交的公共逻辑
    HandlePostFunc(anewAndSure, secondSave) {
      const dispatch = this.dispatchComponent
      if (dispatch) {
        // filterRepeatKey 以什么key字段过滤重复的数据 表格行配置的按钮新增数据到表单表格里
        this.dispatch(dispatch.componentName, dispatch.eventName, {
          data: this.formData,
          repeatFilter: dispatch.repeatFilter,
          vm: this,
        })
        // this.showModal = false;
        return
      }
      const that = this
      let btnContent = this.btnConfirmObj.content
      try {
        if (that.btnConfirmIsDynamic) btnContent = eval(that.btnConfirmObj.content)
        // 模拟错误
        throw new Error('error')
      } catch (e) {
        console.error('发生错误：', e.message)
        if (this.showSaveConfirm && btnContent) {
          this.$pgMessage.confirm({
            title: this.btnConfirmObj.title,
            content: btnContent,
            onOk: (dead) => {
              if (dead) dead()
              // 需求7134
              if (this.beforeSubmitAction) {
                this.store
                  .dispatch(
                    this.beforeSubmitAction,
                    {
                      data: this.formData,
                    },
                    this
                  )
                  .then((res) => {
                    if (res.errors && res.errors.length > 0) {
                      this.responseData = res
                    } else {
                      this.saveDate(anewAndSure, this.formData, secondSave)
                    }
                  })
              } else {
                this.saveDate(anewAndSure, this.formData, secondSave)
              }
            },
          })
        } else {
          // 需求7134
          if (this.beforeSubmitAction) {
            this.store
              .dispatch(
                this.beforeSubmitAction,
                {
                  data: this.formData,
                },
                this
              )
              .then((res) => {
                if (!res) return
                if (res.errors && res.errors.length > 0) {
                  // 将提交前操作后产生的错误信息展示在页面顶部（eg 【待处理-来自备货收货通知单、待处理-来自跟台收货通知单】的【生成xx验收单】页面）
                  this.responseData = res
                } else {
                  this.saveDate(anewAndSure, this.formData, secondSave)
                }
              })
          } else {
            this.saveDate(anewAndSure, this.formData, secondSave)
          }
        }
      }
    },
  },
}
</script>
<style></style>
